import { Injectable } from '@angular/core';
import { firstValueFrom, tap } from 'rxjs';
import { ReactiveList } from '@dg/shared-rsm';

import { ProfileCollectionItem } from '@app/profile/profile-api.model';

import { InputDetails } from '@app/inputs/inputs-api.model';
import { Profile } from '@app/profile/profile.model';
import { ProfileService } from '@app/profile/services/profile.service';
import { ProfileLearningServiceV2 } from '@app/profile/components/profile-overview/learning-v2/profile-learning.service';
import { getTotalCountFromFacets } from '@app/profile/components/profile-overview-v2/profile-overview.utils';
import { INPUTS_DISPLAY_LIMIT } from '@app/profile/components/profile-overview-v2/profile-overview.facade';

export interface LearningItem extends ProfileCollectionItem<InputDetails> {
  id: string;
}

@Injectable()
export class ProfileLearningFacade {
  public learningItems = new ReactiveList<LearningItem>('profileLearning');

  private get owner(): Profile {
    return this.profileService.profileInput.profile;
  }

  constructor(
    private profileLearningsService: ProfileLearningServiceV2,
    private profileService: ProfileService
  ) {}

  public async getLearnings(
    tagName: string,
    reset: boolean = false,
    count = INPUTS_DISPLAY_LIMIT
  ): Promise<any> {
    const learnings = await firstValueFrom(this.learningItems.list$);
    const skip = reset ? 0 : learnings.length;
    return firstValueFrom(
      this.profileLearningsService
        .getMostRecentLearningsModel(
          this.owner.id,
          skip,
          count,
          tagName,
          '',
          []
        )
        .pipe(
          this.learningItems.trackLoadStatus,
          tap(({ items, facets }) => {
            const collectionItems =
              this.profileLearningsService.extractLearningItemsFromModel(items);
            this.learningItems.addItems(
              collectionItems,
              reset,
              getTotalCountFromFacets(facets)
            );
            this.learningItems.setLoading(false);
          })
        )
    );
  }
}
